import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import AuthorsIndex from 'components/Authors/AuthorsIndex'
import { AuthorsStore } from 'stores/authors'
import { usePageView, useStore } from 'hooks'
import { getStaticWrapper } from 'utils'

const AuthorsIndexPage = ({ authors }) => {
  useStore(AuthorsStore, { items: authors })

  usePageView((ga) => {
    ga.customDimensions.setPageType('Bloggers')
  })

  return (
    <SiteLayout>
      <Head
        title='Barstool Sports Bloggers | Barstool Sports'
        description='See a list of all bloggers and personalities at Barstool Sports like Dave Portnoy, Big Cat, KFC, John Feitelberg, PFT Commenter and more.'
      />
      <AuthorsIndex />
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper(async () => {
  const authors = await AuthorsStore().find()
  return {
    authors
  }
})

export default AuthorsIndexPage
